import React, { Fragment } from "react";


import Button from "../../components/Button/Button";

import "./Summary.css";
import "../../styles/uikit.css";
import "../../styles/font-awesome-4.7.0/css/font-awesome.min.css";

class Summary extends React.Component {
  // constructor(props) {
  //   super(props);
  //   //this.toggleClass = this.toggleClass.bind(this);
  //   //this.state = { active: new Array(props.categories.length).fill(false) };
  // }


  render() {
    return (
      <Fragment>
        <div className="mn-content-categories__summary-breadcrumbs">
          <span className="">گروه کالایی انتخابی شما:</span>
          <ul className="mn-content-categories__selected-list">
            {this.props.summeries &&
              this.props.summeries.map((summery, i) => {
                return (
                  <li
                    key={i}
                    className={"mn-content-categories__selected-category"}
                  >
                    {summery}
                  </li>
                );
              })}
          </ul>
        </div>

        <div className="c-content-accordion__step-controls c-content-accordion__step-controls--category">
          {this.props.summeries.length == 0 && this.props.noneable && 
            <Button
              design="next"
              mode=""
              type="submit"
              loading={false}
              onClick={this.props.onAddHandler}
            >
              {"درج گروه کالایی"}
            </Button>
          }
          {this.props.summeries.length == 0 && !this.props.noneable && !this.props.isChildSummerySelected &&
            <Button
              design="next"
              mode="disable"
              type="submit"
              loading={false}
              onClick={this.props.onAddHandler}
            >
            {"انتخاب گروه کالا"}
            </Button>
          }
          {this.props.summeries.length != 0 && !this.props.noneable && !this.props.isChildSummerySelected &&
            <Button
              design="next"
              mode="disable"
              type="submit"
              loading={false}
              onClick={this.props.onAddHandler}
            >
            {"انتخاب گروه کالا"}
            </Button>
          }
          {this.props.summeries.length != 0 && !this.props.noneable && this.props.isChildSummerySelected &&
          <Button
            design="next"
            mode=""
            type="submit"
            loading={false}
            onClick={this.props.addCategoryParentHandler}
          >
            {"انتخاب گروه کالا"}
          </Button>
          }
          {this.props.summeries.length != 0 && this.props.noneable &&
          <Button
            design="next"
            mode=""
            type="submit"
            loading={false}
            onClick={this.props.addCategoryParentHandler}
          >
            {"انتخاب گروه کالا"}
          </Button>
          }
          <Button
            design="reset"
            mode=""
            type="submit"
            loading={false}
            onClick={this.props.newResetHandler}
          >
            {}
          </Button>
        </div>
      </Fragment>
    );
  }
}

export default Summary;
